class ct_cart_drawer extends HTMLElement {
  constructor() {
    super();
    this.setMaxHeight();
    this.querySelector("[closer]").addEventListener("click", () => {
      this.close();
    });
    this.previousElementSibling.addEventListener("click", () => {
      this.close();
    });
    const removers = this.querySelectorAll(".ct-cart-quantity-remove");
    removers.forEach((remove) => {
      remove.addEventListener("click", () => {
        this.removeLineItem(remove.getAttribute("data-id"));
      });
    });
    const qControls = this.querySelectorAll(".ct-cart-lineItem-quantity-button");
    qControls.forEach((control) => {
      control.addEventListener("click", () => {
        this.controlQuantity(control);
      });
    });
    const inputs = this.querySelectorAll(".ct-cart-lineItem-quantity-control input");
    inputs.forEach((input) => {
      const maximum = parseInt(input.getAttribute("max"));  
      const id = input.getAttribute("data-id");
      input.addEventListener("input", (e) => {
        if(input.value >= 1) {
          if(input.value == 1) {
            input.previousElementSibling.removeAttribute("disabled");            
          }
          const quantity = parseInt(input.value);
          this.changeCart(id, quantity);
        } else {
          if(input.value != null) {
            fetch(window.Shopify.routes.root + 'cart.js')
              .then(response => response.json())
              .then(data => {
                const line = data.items.find(item => item.id.toString() === id);
                input.value = line.quantity;
                return data;
              });
            e.preventDefault();
          }
        } 
      });
    });
  }

  controlQuantity(element) {
    if(element.classList.contains("ct-cart-minus")) {
      if(!element.hasAttribute("disabled")) {
        const input = element.nextElementSibling;
        const id = input.getAttribute("data-id");
        const currentQuantity = parseInt(input.value);
        if(currentQuantity > 1) {
          this.changeCart(id, (currentQuantity - 1));
          input.value = currentQuantity - 1;
          if(input.nextElementSibling.hasAttribute("disabled")) {
            input.nextElementSibling.removeAttribute("disabled");
          }
          if((currentQuantity - 1) == 1) {
            element.setAttribute("disabled", "");
          }
        }
      }
    } else if(element.classList.contains("ct-cart-plus")) {
      if(!element.hasAttribute("disabled")) {
        const input = element.previousElementSibling;
        const id = input.getAttribute("data-id");
        const currentQuantity = parseInt(input.value);
        this.changeCart(id, (currentQuantity + 1));
        input.value = currentQuantity + 1;
        if(input.previousElementSibling.hasAttribute("disabled")) {
          input.previousElementSibling.removeAttribute("disabled");
        }
      }
    }
  }
  changeCart(id, quantity) {
    const shoppingBag = document.querySelector("ct-shoppingbag");
    let update = {
      'id': id.toString(),
      'quantity': quantity
    }
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": 'application/json'
      },
      body: JSON.stringify(update)
    })
    .then(response => {
      if(!response.ok) {
        return response.json().then(errorData => {
          const errorWrapper = document.querySelector("ct-error-wrapper");
          errorWrapper.launchError(errorData.message);
        });
      } else {
        shoppingBag.refresh();
        this.lightDrawerUpdate();
        return response.json();
      }
    })
    .catch((error) => {
      console.error("Error from ct-cart-drawer.js: " + error);
    });
  }
  removeLineItem(id) {
    this.changeCart(id, 0);
    const lineItem = this.querySelector("[lineItemID='" + id + "']");
    lineItem.classList.add("ct-cart-delete-lineItem");
    setTimeout(() => {
      lineItem.remove();
    }, 500);
  }
  lightDrawerUpdate() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        for(let i = 0; i < data.items.length; i++) {
          const item = data.items[i];
          const line = this.querySelector("[lineitemid='" + item.id + "']");
          const uP = item.final_line_price / 100;
          
          const price = uP.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
          line.querySelector(".ct-cart-price").innerText = window.ct_currency.symbol + price;
        }
        const uPP = data.items_subtotal_price / 100;
        const subtotal = uPP.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
        this.querySelector("[ct-subtotal]").innerText = window.ct_currency.symbol + subtotal;
        this.updateProgressBar();
        return data;
      });
  }
  heavyDrawerUpdate() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        const gc_icon = (window.ct_cart.gc_icon != "unset") ? `<img src="${window.ct_cart.gc_icon}" width="20" height="20" alt="Good Choice Icon">` : `
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="{{ settings.gc_textcolor }}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5"></path>
          </svg>
        ` ;

        let itemsCode = ``;
        
        for(let i = 0; i < data.items.length; i++) {
          const item = data.items[i];
          const uP = item.final_line_price / 100;
          const linePrice = uP.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          let variant_title = ``;
          if(item.variant_title !== "" && item.variant_title !== null) {
            variant_title = `<span class="ct-cart-variant-name">${item.variant_title}</span>`;
          }
          let disabler = ``;
          if(item.quantity == 1){
            disabler = " disabled"
          }
          itemsCode = itemsCode + `
            <div class="ct-cart-lineItem" lineItemID="${item.id}">
              <div class="ct-cart-lineItem-image">
                <img src="${item.image}" alt="Produktfoto von ${item.product_title}">
              </div>
              <div class="ct-cart-lineItem-infos">
                <span class="ct-cart-lineItem-title">${item.product_title}</span>
                <span class="ct-cart-price">${window.ct_currency.symbol}${linePrice}</span>
                ${variant_title}
                <div class="ct-cart-lineItem-quantity">
                  <div class="ct-cart-lineItem-quantity-control">
                    <div class="ct-cart-lineItem-quantity-button ct-cart-minus"${disabler}>
                      <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14"></path>
                      </svg>
                    </div>
                    <input type="number" min="1" data-id="${item.id}" value="${item.quantity}">
                    <div class="ct-cart-lineItem-quantity-button ct-cart-plus">
                      <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7 7V5"></path>
                      </svg>
                    </div>
                  </div>
                  <span class="ct-cart-quantity-remove" data-id="${item.id}">${window.ct_cart.li_remove}</span>
                </div>
              </div>
            </div>
          `;
        }

        const LI_wrapper = `
          <div class="ct-cart-goodChoice">
            ${gc_icon}
            <span>${window.ct_cart.gc_text}</span>
          </div>
          <div class="ct-cart-lineItems">
            ${itemsCode}
          </div>
        `;

        this.querySelector(".ct-cart-lineWrapper").innerHTML = LI_wrapper;
        this.lightDrawerUpdate();

        const atcbtn = this.querySelector(".ct-cart-checkout");
        if(data.item_count > 0) {
          atcbtn.removeAttribute("disabled");
        } else if(data.item_count <= 0) {
          atcbtn.setAttribute("disabled", "disabled");
        }

        const removers = this.querySelectorAll(".ct-cart-quantity-remove");
        removers.forEach((remove) => {
          remove.addEventListener("click", () => {
            this.removeLineItem(remove.getAttribute("data-id"));
          });
        });
        const qControls = this.querySelectorAll(".ct-cart-lineItem-quantity-button");
        qControls.forEach((control) => {
          control.addEventListener("click", () => {
            this.controlQuantity(control);
          });
        });
        const inputs = this.querySelectorAll(".ct-cart-lineItem-quantity-control input");
        inputs.forEach((input) => {
          const maximum = parseInt(input.getAttribute("max"));  
          const id = input.getAttribute("data-id");
          input.addEventListener("input", (e) => {
            if(input.value >= 1) {
              if(input.value == 1) {
                input.previousElementSibling.removeAttribute("disabled");            
              }
              const quantity = parseInt(input.value);
              this.changeCart(id, quantity);
            } else {
              if(input.value != null) {
                fetch(window.Shopify.routes.root + 'cart.js')
                  .then(response => response.json())
                  .then(data => {
                    const line = data.items.find(item => item.id.toString() === id);
                    input.value = line.quantity;
                    return data;
                  });
                e.preventDefault();
              }
            } 
          });
        });
        this.updateProgressBar();
        const shoppingBag = document.querySelector("ct-shoppingbag");
        shoppingBag.refresh();
        this.open();
        setTimeout(() => {
          this.close();
        }, 2000);
        this.setMaxHeight();
        return data;
      });
  }
  updateProgressBar() {
    const wrapper = this.querySelector(".ct-cart-progress");
    const min = parseFloat(wrapper.getAttribute("data-min"));
    const fullBar = wrapper.querySelector(".ct-cart-fullbar");
    const priceSpan = this.querySelector("#ct-cart-remaining");
    fetch(window.Shopify.routes.root + "cart.js")
      .then(response => response.json())
      .then(data => {
        const total = data.total_price / 100;
        if(total >= min) {
          fullBar.style.width = "100%";
          this.querySelector("#ct-cart-progress-remaining").innerText = window.ct_cart.prog_qualtext;
        } else {
          const progText = window.ct_cart.prog_text;
          const rem = min - total;
          const progHTML = progText.replace("[remaining]", '<span id="ct-cart-remaining">' + window.ct_currency.symbol + rem.toFixed(2).replace(/\.(?=\d{2}$)/, ',') + '</span>')
          this.querySelector("#ct-cart-progress-remaining").innerHTML = progHTML;
          const width = (total * 100) / min;
          fullBar.style.width = width + "%";
        }
        return data;
      });
  }
  setMaxHeight() {
    if(this.querySelector(".ct-cart-goodChoice")) {
      const fullHeight = this.offsetHeight;
      const headerHeight = this.querySelector(".ct-cart-header").offsetHeight;
      const progHeight = this.querySelector(".ct-cart-progress").offsetHeight;
      const paddingTop = parseFloat(getComputedStyle(this.querySelector(".ct-cart-lineWrapper")).paddingTop);
      const choiceHeight = this.querySelector(".ct-cart-goodChoice").offsetHeight;
      const footerHeight = this.querySelector(".ct-cart-footer").offsetHeight;
      const maxHeight = fullHeight - headerHeight - progHeight - paddingTop - paddingTop - choiceHeight - footerHeight;
      this.querySelector(".ct-cart-lineItems").style.maxHeight = maxHeight + "px";
    }
  }
  toggleDrawer() {
    if(this.hasAttribute("visible")) {
      this.close();
    } else {
      this.open();
    }
  }
  open() {
    this.setAttribute("visible", "");
    this.previousElementSibling.setAttribute("visible", "");
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
  }
  close() {
    this.removeAttribute("visible");
    this.previousElementSibling.removeAttribute("visible");
    document.body.style.overflow = "auto";
    document.body.style.touchAction = "";
  }
}
customElements.define("ct-cart-drawer", ct_cart_drawer);